import type { CaptureResult } from "posthog-js/dist/module.slim";

import { AnalyticsEvent, POSTHOG_INTERNAL_EVENTS } from "./analytics-events";

const ALLOWED = new Set<string>([
  ...Object.values(AnalyticsEvent),
  ...POSTHOG_INTERNAL_EVENTS,
]);

/**
 * posthog-js `before_send`: returning null drops the event before it is queued,
 * so an unexpected capture costs nothing in bandwidth or ingestion.
 */
export const allowlistBusinessEvents = (
  event: CaptureResult | null
): CaptureResult | null => {
  if (!event) return null;
  return ALLOWED.has(event.event) ? event : null;
};
